var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.files.concat( [{ id: Math.random() }])),function(file){return [_c('InputFile',_vm._b({key:file.id,on:{"input":function($event){return _vm.onInput($event, file.id)}}},'InputFile',_vm.inputProps(file),false))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }